import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'Lucía',
  role: 'profe de 8 años en Córdoba',
  messages: ['¡Hola! Ayer usé el ProfePack por primera vez y me salvó.', 'Tenía un grupo re mezclado y no sabía cómo armar las progresiones sin que se me aburran las más avanzadas.', 'Armé la clase en 5 min literal 🙌'],
  avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=150&auto=format&fit=crop'
}, {
  name: 'Martín',
  role: 'Profe de Club, CABA',
  messages: ['Excelente el material. Muy bien explicado todo.', 'Lo que más me sirvió fue la parte de seguridad y prevención.', 'Ya lo recomendé a otros profes del club. ¡Abrazo!'],
  avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?q=80&w=150&auto=format&fit=crop'
}];
export function Testimonials() {
  return <section className="w-full bg-cream py-20 px-4 sm:px-6 lg:px-8" data-id="element-215">
      <div className="max-w-5xl mx-auto" data-id="element-216">
        <div className="text-center mb-16" data-id="element-217">
          <span className="text-primary font-bold tracking-widest text-sm uppercase mb-3 block" data-id="element-218">
            Testimonios reales
          </span>
          <h2 className="text-3xl sm:text-4xl font-heading font-black text-navy mb-4" data-id="element-219">
            Lo que dicen los profes que lo usan
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto mb-16" data-id="element-220">
          {testimonials.map((t, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.2
        }} className="bg-[#EFEAE2] rounded-3xl overflow-hidden shadow-lg border border-gray-200/50 flex flex-col" data-id="element-221">
              {/* WhatsApp Header */}
              <div className="bg-[#075E54] text-white p-4 flex items-center gap-3" data-id="element-222">
                <img src={t.avatar} alt={t.name} className="w-10 h-10 rounded-full object-cover border border-white/20" data-id="element-223" />
                <div data-id="element-224">
                  <div className="font-bold text-sm" data-id="element-225">{t.name}</div>
                  <div className="text-xs text-white/70" data-id="element-226">{t.role}</div>
                </div>
              </div>

              {/* WhatsApp Body */}
              <div className="bg-[#E5DDD5] p-6 flex-1 flex flex-col gap-3 relative" style={{
            backgroundImage: 'url("https://w0.peakpx.com/wallpaper/818/148/HD-wallpaper-whatsapp-background-cool-dark-green-new-theme-whatsapp.jpg")',
            backgroundSize: 'cover',
            backgroundBlendMode: 'overlay'
          }} data-id="element-227">
                {t.messages.map((msg, mIdx) => <div key={mIdx} className="bg-[#DCF8C6] text-[#303030] p-3 rounded-2xl rounded-tr-none self-end max-w-[85%] shadow-sm text-sm relative" data-id="element-228">
                    {msg}
                    <div className="absolute right-2 bottom-1 text-[10px] text-gray-500 flex items-center gap-1" data-id="element-229">
                      14:{30 + mIdx} <span className="text-blue-500" data-id="element-230">✓✓</span>
                    </div>
                  </div>)}
              </div>
            </motion.div>)}
        </div>

        {/* Stats */}
        <div className="grid grid-cols-3 gap-4 max-w-3xl mx-auto text-center divide-x divide-gray-200" data-id="element-231">
          <div data-id="element-232">
            <div className="text-3xl sm:text-4xl font-heading font-black text-navy mb-1" data-id="element-233">
              500+
            </div>
            <div className="text-sm font-medium text-gray-500 uppercase tracking-wider" data-id="element-234">
              Clientes
            </div>
          </div>
          <div data-id="element-235">
            <div className="text-3xl sm:text-4xl font-heading font-black text-navy mb-1 flex items-center justify-center gap-1" data-id="element-236">
              4.9 <Star className="w-5 h-5 text-primary fill-primary" data-id="element-237" />
            </div>
            <div className="text-sm font-medium text-gray-500 uppercase tracking-wider" data-id="element-238">
              Calificación
            </div>
          </div>
          <div data-id="element-239">
            <div className="text-3xl sm:text-4xl font-heading font-black text-navy mb-1" data-id="element-240">
              100%
            </div>
            <div className="text-sm font-medium text-gray-500 uppercase tracking-wider" data-id="element-241">
              Satisfacción
            </div>
          </div>
        </div>
      </div>
    </section>;
}